import {
  RevenueClassification,
  RevenueRecognitionMethod
} from 'common/types/revenueRecognition.types'

export function mergeLineItemsIntoGroups<
  Group extends { id: string },
  LineItem extends {
    groupId: string
    revenueRecognitionMethod?: RevenueRecognitionMethod
    revenueClassification?: RevenueClassification
  },
  AggregatedGroup = Group & {
    lineItems: LineItem[]
    revenueRecognitionMethod?: string
    revenueClassification?: string
  }
>(lineItems: LineItem[], groups: Group[]): AggregatedGroup[] {
  return groups.map(group => {
    const groupLineItems = lineItems.filter(
      lineItem => lineItem.groupId === group.id
    )
    const firstLineItem = groupLineItems[0]

    return {
      ...group,
      lineItems: groupLineItems,
      revenueRecognitionMethod: firstLineItem?.revenueRecognitionMethod,
      revenueClassification: firstLineItem?.revenueClassification
    } as AggregatedGroup
  })
}
